import { logEvent } from './actions';
import * as AnalyticsConstants from './constants';
import * as D from './deps';
import AnalyticsWatchers from './sagas/watchers';
import * as AnalyticsUtils from './utils';

export default D.createDomainModule({
  name: 'analytics',
  actions: {
    logEvent,
  },
  components: null,
  reducer: null,
  constants: AnalyticsConstants,
  utils: AnalyticsUtils,
  onStart() {
    this.registeredHandlers = D.registerHandlers(AnalyticsWatchers);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
